import { useState } from 'react';
import { X, AlertCircle } from 'lucide-react';

interface Props {
  tcId: string;
  tcTitle: string;
  onConfirm: (actualResult: string) => void;
  onCancel: () => void;
  isPending?: boolean;
}

export default function FailActualResultModal({
  tcId,
  tcTitle,
  onConfirm,
  onCancel,
  isPending,
}: Props) {
  const [actualResult, setActualResult] = useState('');

  const canSubmit = actualResult.trim().length > 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <AlertCircle className="size-5 text-red-500" />
            <h3 className="text-base font-semibold text-gray-900">FAIL 결과 기록</h3>
          </div>
          <button
            onClick={onCancel}
            className="p-1 rounded text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          >
            <X className="size-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          <div className="text-sm text-gray-600">
            <span className="font-medium text-gray-900">{tcId}</span>{' '}
            {tcTitle}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              실제 결과 <span className="text-red-500">*</span>
            </label>
            <textarea
              value={actualResult}
              onChange={(e) => setActualResult(e.target.value)}
              rows={3}
              placeholder="실제 동작 결과를 입력하세요..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none resize-none"
              autoFocus
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-2 px-6 py-4 border-t border-gray-200">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            취소
          </button>
          <button
            onClick={() => onConfirm(actualResult.trim())}
            disabled={!canSubmit || isPending}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {isPending ? '기록 중...' : 'FAIL 기록'}
          </button>
        </div>
      </div>
    </div>
  );
}
